module.exports = __webpack_public_path__ + "img/mp.944e2515.svg";